import 'babel-polyfill';
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueCookies from 'vue-cookies';
import FlagIcon from 'vue-flag-icon'
import Hub from '@/libs/signalR/signalr';
import { ConnectionStatus, RunStates } from '@/libs/signalR/vuexStore/store/state';
import { HubConnectionState } from '@microsoft/signalr';
import ApiRequest from './libs/apiRequest';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import { EventBus, EVENTS } from './libs/eventBus';

Vue.config.productionTip = false;
Vue.use(VueResource);

Vue.use(VueCookies);
// set default config
Vue.$cookies.config('30d');

const apiRequest = new ApiRequest(store, Vue.http, i18n);
const hub = new Hub(store, Vue.http, i18n);
const isAuthenticated = function (myStore, myCookies) {
  const cookie = myCookies.get('gdpr');

  if (!cookie) {
    // Clear the current state, if the cookie is not allowed
    myStore.commit('clearState');
  }

  return myStore.getters.bearerToken() != null;
};

const isBlocked = function (myStore, myHub) {
  const { runState } = myStore.state.signalR
  const runInfo = myStore.state?.runInfo;
  // is Hub connection established
  if (myHub.connection && myHub.connection.state === HubConnectionState.Connected) {
    // if the hub is connected, check if the State is blocking
    return runState === RunStates.RunEdit
  }
  return runInfo?.runInformation?.runState < 2 || runInfo?.runInformation?.runState > 5
}

// Setup route guard
router.beforeEach((to, from, next) => {
  const authorized = isAuthenticated(store, Vue.$cookies);
  // check authentication and if route needs auth
  if (!authorized && to.meta.requiresAuthentication) {
    console.log('redirect to login')
    next({ name: 'login' })
    return;
    // check if runstate is blocking
  }
  if (authorized && (!hub.connection || hub.connection.state !== HubConnectionState.Connected)) {
    hub.setup()();
  }
  if (authorized && isBlocked(store, hub) && !to.meta.isBlocker) {
    console.log('redirect to blocker')
    next({ name: 'blocker' })
  } else next();
});

router.afterEach((to, from, next) => {
  EventBus.$emit(EVENTS.ROUTE_PUSHED);
});

Vue.use(FlagIcon);

new Vue({
  router,
  store,
  vuetify,
  apiRequest,
  hub,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
